/**
 * L2 (Eric via Master, 2026-10-29): who changed each client-portal settings card, and when.
 * GET /admin/portal/settings/history reads the audit rows the saves already write (superadmin).
 */
import { adminFetch } from '@/lib/adminApi';
import type { EntityKey } from '@/lib/portalCoiSettingsApi';

/** One change, newest first on its card. `by` is the person's name ("Unknown" when not on record). */
export interface SettingsHistoryEntry { at: string; by: string; summary: string }
export type SettingsHistoryCards = Record<string, SettingsHistoryEntry[]>;

/** The card keys, as the server (portalSettingsHistory.js) writes them. */
export const historyKey = {
  holder: (entity: EntityKey) => `coi:holder:${entity}`,
  limits: 'coi:limits',
  regions: 'coi:regions',
  agreement: (entity: EntityKey) => `agreement:${entity}`,
} as const;

export async function getSettingsHistory(): Promise<SettingsHistoryCards> {
  const res = await adminFetch<{ cards?: SettingsHistoryCards }>('/portal/settings/history');
  return res.cards ?? {};
}
